import { TrustAccountingIcon } from "./trust-account";

export enum BaseIcon {
    ADD = 'mdi:plus',
    EDIT = 'mdi:pencil',
    DELETE = 'mdi:delete',
    VIEW = 'iconamoon:eye',
    SEARCH = 'mdi:search',
    FILTER = 'mdi:filter',
    SORT = 'mdi:sort',
    DOWNLOAD = 'lucide:download',
    UPLOAD = 'lucide:upload',
    PRINT = 'mdi:printer',
    COPY = 'mdi:content-copy',
    ARCHIVE = 'lucide:archive',
    RESTORE = 'lucide:archive-restore',
    EMPTY = 'mdi:alert-circle-outline',
    EXTERNAL_LINK = 'mynaui:external-link',
    RENAME = 'mdi:form-textbox',
    DUPLICATE = 'mdi:content-duplicate',
    MOVE = 'mdi:cursor-move'
}

export enum SidebarIcon {
    DASHBOARD = 'hugeicons:home-05',
    BUSINESS = 'hugeicons:building-01',
    PIPELINE='bi:kanban',
    CONTRACTS = 'hugeicons:contracts',
    TRUST_ACCOUNTING = 'hugeicons:dollar-02',
    CONTACTS = 'streamline-ultimate-color:multiple-users-2',
    TASKS = 'mdi:checkbox-marked-circle-outline',
    TEMPLATES = 'lucide:layout-template',
    AUTOMATIONS = 'carbon:workflow-automation',
    CAMPAIGN = 'material-symbols:campaign-outline-rounded',
    CALENDAR = 'lucide:calendar',
    SETTINGS = 'lucide:settings',
    USERS = 'ci:users',
    BILLING = 'lucide:credit-card',
    RESOURCES = 'mynaui:external-link',
    ACTIVITY = 'radix-icons:activity-log',
}

export enum ContactDetailIcon {
    SUMMARY = 'mdi:robot-outline',
    PROFILE = 'icomoon-free:profile',
    ACTIVITY = SidebarIcon.ACTIVITY,
    AUTOMATION = SidebarIcon.AUTOMATIONS,
}

// Business Profile - hugeicons:profile-02

// Business Files - mdi-light:folder

// Business Dashboard - mdi-light:calendar

// Business Advertisement - mdi-light:bullhorn

// Business Sharing - mdi-light:share-variant

// CIM Access Manager - mdi-light:lock

// Buyer Analytics - mdi-light:chart-line

// Automation Manager - SAME

export enum SettingIcon {
    BRAND = 'lucide:palette',
    BUSINESS = 'lucide:briefcase',
    FEATURES = 'lucide:toggle-right',
    LISTINGS = 'lucide:layout-grid',
    INTEGRATION = 'lucide:webhook',
    AUTHENTICATION = 'lucide:shield-check',
    EMAIL_COMPLIANCE = 'lucide:mail-check',
    BILLING = SidebarIcon.BILLING,
}


export enum BusinessDetailIcon {
    PROFILE = 'hugeicons:profile-02',
    FILES = 'mdi-light:folder',
    FILE_SHARING = 'mdi-light:share',
    DASHBOARD = SidebarIcon.ACTIVITY,
    ADVERTISEMENT = 'mdi-light:bullhorn',
    MARKETING = 'lineicons:megaphone-1',
    SHARING = 'mdi-light:share-variant',
    EDITOR = 'mdi-light:clipboard',
    CIM_ACCESS_MANAGER = 'mdi-light:lock',
    ACQUISITION_LEADS = 'mdi-light:leads',
    ANALYTICS = 'mdi-light:chart-line',
    AUTOMATION_MANAGER = SidebarIcon.AUTOMATIONS,


    //  quick links
    APPRAISAL = 'ph:calculator-light',
    PROPOSAL = 'fluent:document-sparkle-24-light',
    CIM = 'streamline-sharp:graphic-template-website-ui',
    CONTRACT = SidebarIcon.CONTRACTS,
    TEASER="ph:presentation-chart-light",
    VIDEO_RECORDER = 'tabler:video',
    VIRTUAL_DATA_ROOM = 'majesticons:data-line',

}

export enum ContractIcons {
    DETAILS = BusinessDetailIcon.PROFILE,
    ACTIVITY = SidebarIcon.ACTIVITY,
    FILES = 'mdi-light:file',
    TRANSACTIONS = TrustAccountingIcon.TRANSACTION,
}




